module.exports = __webpack_public_path__ + "static/orkut_3-8ceb1382165938a81ca839bbbf7abf6b.png";